import { isly } from "isly";
export var SE;
(function (SE) {
    var _a;
    _a = isly
        .object({
        countryCode: isly.string("value", "SE"),
        street: isly.string(),
        zipCode: isly.string(),
        city: isly.string(),
    }, "isoly.Address.SE")
        .bind(), SE.type = _a.type, SE.is = _a.is, SE.flawed = _a.flawed;
})(SE || (SE = {}));
//# sourceMappingURL=SE.js.map